import axios, { AxiosResponse } from 'axios';
import CryptoJS from 'crypto-js';
import { envUrls } from '../data/objects/env';

import {
  CertificateType,
  CLASSIFICATION,
  DiamondClarity,
  DiamondColor,
  DiamondShape,
  FieldBraceletStyleFromSimple,
  FieldBrandFromSimple,
  FieldCertificateFromSimple,
  FieldCertificateFromSimpleGemstone,
  FieldClarityFromSimple,
  FieldClarityFromSimpleGemstone,
  FieldColorFromSimple,
  FieldColorFromSimpleGemstone,
  FieldConditionFromSimple,
  FieldEarringsStyleFromSimple,
  FieldMetaTypeFromSimple,
  FieldNecklaceStyleFromSimple,
  FieldShapeFromSimple,
  FieldShapeFromSimpleGemstone,
  FieldStyleFromSimple,
  FieldWatchBrandFromSimple,
  GemstoneColor,
  ItemTypes,
  MetalTypes,
  Subsets,
} from '../data/ItemDetails';

import { getSessionData, isIframe, toSnakeCase } from '../lib/commonUtils';
import type { ItemInputsTypes, SubmitState } from '../slices/submitSlice';
import { CookieStore } from './cookieStore';
import type { GenerateShippingParams, SchedulingType } from '../types/scheduling';

const { REACT_APP_SITE_URL, REACT_APP_SELLER_DASHBOARD_BE_URL } = process.env;

export const DEFAULT_PHONE = '0000000001';

export enum MediumTypes {
  email = 'email',
  sms = 'sms',
  anyMedium = 'anyMedium',
}
const mockResponseForCreateShipping = {
  item: {
    // workflow_state: 'shipping',
    // id: '4626085',
    // item_in_cui_states: true,
    // format: 'auction',
    // item_type_name: 'Rings',
    // item_type: 'ring',
    // restrict_jb_seller_from_entering_auction_const: false,
    // restrict_jb_seller_enter_pending_auction: false,
    // not_empty: true,
    // desc: '1.5 - 1.99 CT Round Cut Solitaire Ring',
    // photos: [],
    // has_submission_photo: false,
    // photo_validation_review: '',
    // drop_off_offices: [],
    // enabled_drop_off_offices_circa_keys: [],
    // premium_brand: false,
    // fake_estimate: false,
    // bundle: {
    //   workflow_state: 'pickup_waiting',
    //   converted_from_std_bundle: false,
    //   jb: false,
    //   id: 962560,
    //   address: {
    //     street: '2907 West Lombard Street',
    //     street2: '',
    //     city: 'Springfield',
    //     state: 'MO',
    //     zipcode: '65802',
    //   },
    // },
    // is_photo_mandatory: false,
    // is_insurance_limit_reached: false,
    // display_optional_phone_label: false,
    // submission_qualification: 0,
    // submission_qualification_reason:
    //   'Approved - item estimation is over skip photo higher treshhold($1000)',
    // value_category: 'High Value',
    // high_value_estimation: true,
    // auto_reestimate: false,
    // additional_items: [],
    // prereg_score: null,
    // similar_items: [],
    // avoid_listing_page: false,
    // is_new_user: false,
    // reschedule_pickup_attempts: 0,
    // properties: {
    //   jewelry_style_ring: 'Solitaire',
    //   jewelry_metal_type: '14K Gold',
    //   plain_stone_type_name: 'diamond',
    //   diamond_shape: 'Round',
    //   diamond_carat_weight: '1.5',
    //   diamond_carat_weight_to: '1.99',
    //   diamond_color: 'Not Sure',
    //   diamond_clarity: 'Not Sure',
    //   diamond_type: 'Natural',
    //   jewelry_subset_system_name: 'jewelry_rings',
    //   stone_type: 'Diamond',
    //   jewelry_system_name: 'jewelry',
    // },
    // submit_timestamp: '2025-06-18T10:49:17.660Z',
    // sold_last_x_days_count: 0,
    // listing_page_no_phone_modal: {
    //   enable_listing_draft_no_phone_survey: true,
    //   listing_draft_no_phone_survey_delay: 20,
    // },
    // estimation: {
    //   valid_for_shipping_kit: true,
    //   amount: 5600.19,
    // },
    shipment: {
      id: 402002,
      locations: [
        {
          location_id: 'SFOKK',
          location_type: 'FEDEX_OFFICE',
          name: 'FedEx Office Print & Ship Center',
          address: {
            StreetLines: '3225 Fillmore St',
            City: 'Springfield',
            StateOrProvinceCode: 'CA',
            PostalCode: '65802',
            CountryCode: 'US',
            Residential: false,
            GeographicCoordinates: '+37.799258-122.436189/',
          },
          distance: {
            Value: '0.567',
            Units: 'MI',
          },
        },
        {
          location_id: '78154',
          location_type: 'FEDEX_AUTHORIZED_SHIP_CENTER',
          name: 'FedEx Authorized ShipCenter',
          address: {
            StreetLines: '3053 Fillmore St',
            City: 'Springfield',
            StateOrProvinceCode: 'CA',
            PostalCode: '65802',
            CountryCode: 'US',
            Residential: false,
            GeographicCoordinates: '+37.797275-122.435436/',
          },
          distance: {
            Value: '0.609',
            Units: 'MI',
          },
        },
      ],
      pickup_availability: [
        {
          cut_off_time: '17:30:00',
          access_time: 3600,
          date: '2025-06-23',
        },
        {
          cut_off_time: '17:30:00',
          access_time: 3600,
          date: '2025-06-27',
        },
        {
          cut_off_time: '14:00:00',
          access_time: 7200,
          date: '2025-06-28',
        },
        {
          cut_off_time: '17:30:00',
          access_time: 3600,
          date: '2025-06-26',
        },
        {
          cut_off_time: '17:30:00',
          access_time: 3600,
          date: '2025-06-29',
        },
        {
          cut_off_time: '17:30:00',
          access_time: 3600,
          date: '2025-06-30',
        },
      ],
      active_pickup: false,
      active_pickup_time: null,
      shipment_method: 2,
      formatted_address: '2907 West Lombard Street, Springfield, MO, 65802',
      shipping_label: {
        url: null,
        original: {
          url: null,
        },
        watermark: {
          url: null,
        },
        large_wide: {
          url: null,
        },
        medium: {
          url: null,
        },
        thumb_wide: {
          url: null,
        },
        thumb: {
          url: null,
        },
        small: {
          url: null,
        },
        featured_small: {
          url: null,
        },
        featured_large: {
          url: null,
        },
        featured_mobile: {
          url: null,
        },
      },
      confirmation_number: null,
      address_resolved_by_fedex: true,
      office_drop_off_appointment: null,
    },
    has_active_appointment: null,
  },
  user: {
    first_name: 'Muhammad',
    last_name: 'Rayyan',
    local_time: '2025-06-22T07:25:27.000-04:00',
  },
};

interface ISubmitItemResponse {
  item: {
    bundle: {
      id: number;
    };
    id: string;
  };
  // eslint-disable-next-line @typescript-eslint/ban-types
  user: {};
}
interface IShippingPickupData {
  ready_timestamp: string;
  company_close_time: string;
  drop_off_locations: Record<number, { name: string; address: string }>;
}

interface IShippingDropOffData {
  itemPublicId: string;
  drop_off_locations: Record<number, { name: string; address: string }>;
}

interface SchedulingDetails {
  type: SchedulingType.DROPOFF | SchedulingType.PICKUP;
  localEndTimeString: string;
  localStartTimeString: string;
  address: string;
  nearestFedExLocations?: string[];
  shipment?: {
    shipmentId: number | null;
    shippingLabelUrl: string;
  };
}
export interface GeneralApiRes {
  status: string;
}
export default class WorthyAPI {
  static defaultOptions = {
    withCredentials: true,
  };

  static async ADO() {
    return axios.get(`${REACT_APP_SITE_URL}/api/v2/sellers/ado`, this.defaultOptions);
  }

  static async createNewMessage(
    content: string,
    submissionId: string,
    conversationId: string | null,
  ): Promise<{ conversationId: string; submissionId: string }> {
    const gaId = CookieStore.getGaId();
    const uvid = CookieStore.getUvid() || gaId;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SUBMIT_BE_URL}/conversation/message`,
        {
          content, submissionId, conversationId, gaId, uvid,
        },
      );

      return {
        conversationId: response.data.conversationId,
        submissionId: response.data.submissionId,
      };
    } catch (err: any) {
      if (window.rollbar?.error) window.rollbar.error('Error sending new message to AI', err);
      console.error('Error sending state', err);

      throw err;
    }
  }

  static async storeStateInBackend(
    state: any,
    user: any,
    trigger: string,
    credential = '',
    data?: any,
  ) {
    return axios
      .post(
        `${process.env.REACT_APP_SUBMIT_BE_URL}/store-state-data`,
        {
          state, user, credential, trigger, data,
        },
        this.defaultOptions,
      )
      .catch((err: any) => {
        // Just log the error
        if (window.rollbar && window.rollbar.error) window.rollbar.error('Error sending state', err);
        console.error('Error sending state', err);
      });
  }

  static async storegClientIdInBackend(submissionId: string, gClientId: string) {
    return axios
      .post(
        `${process.env.REACT_APP_SUBMIT_BE_URL}/store-gcid`,
        { submissionId, gClientId },
        this.defaultOptions,
      )
      .catch((err: any) => {
        // Just log the error
        if (window.rollbar && window.rollbar.error) window.rollbar.error('Error sending gcid', err);
        console.error('Error sending gcid', err);
      });
  }

  static async createItem(params: SubmitState) {
    switch (params.type) {
      case ItemTypes.Earrings:
        return this.createEarringsItem(params);
      case ItemTypes.Necklace:
        return this.createNecklaceItem(params);
      case ItemTypes.LooseDiamond:
        return this.createLooseDiamondItem(params);
      case ItemTypes.Watch:
        return this.createWatchItem(params);
      case ItemTypes.Bracelet:
        return this.createBraceletItem(params);
      default:
        return this.createRingItem(params);
    }
  }

  static getGemstoneStoneSubset(
    params: ItemInputsTypes,
    carat: number,
    caratTo: number | undefined,
    color: string,
    clarity: string,
    type: string,
    typeId?: string,
  ) {
    return {
      type,
      properties_set: {
        item_type: typeId ?? '',
        gemstone_color_shade: 'gemstone_color_shade_na',
        gemstone_cut_grade: 'gemstone_cut_grade_very_good',
        gemstone_polish: 'gemstone_polish_very_good',
        gemstone_symmetry: 'gemstone_symmetry_very_good',
        gemstone_fluorescence_intensity: 'gemstone_fluorescence_intensity_none',
        gemstone_diamond_treated: 'gemstone_diamond_treated_no',
        gemstone_clarity_enhanced: 'gemstone_clarity_enhanced_no',
        gemstone_color_enhanced: 'gemstone_color_enhanced_no',
        gemstone_chips: 'gemstone_chips_none',
        gemstone_inclusions_location: 'gemstone_inclusions_location_none',
        gemstone_inclusions_level: 'gemstone_inclusions_level_eye_clean',
        gemstone_culet_size: 'gemstone_culet_size_none',
        gemstone_culet_condition: 'gemstone_culet_condition_natural',
        gemstone_certificate: FieldCertificateFromSimpleGemstone[params.certificate],
        gemstone_certificate_number: params.certificateNumber,
        gemstone_setting_type: 'gemstone_setting_type_prong',
        gemstone_carat_weight: `${carat}`,
        gemstone_carat_weight_to: `${caratTo ?? ''}`,
        gemstone_shape: FieldShapeFromSimpleGemstone[params.shape],
        gemstone_color: FieldColorFromSimpleGemstone[color],
        gemstone_clarity: FieldClarityFromSimpleGemstone[clarity],
        gemstone_type: 'gemstone_type_other',
        stone_type: 'stone_type_other',
      },
    };
  }

  static getGemstoneMultiStoneSubset(
    params: ItemInputsTypes,
    carat: number,
    caratTo: number | undefined,
    stoneNum: number,
    type: string,
    typeId?: string,
  ) {
    return {
      type,
      properties_set: {
        gemstone_average_color_grade: 'gemstone_average_color_grade_na',
        gemstone_average_clarity_grade: 'gemstone_average_clarity_grade_not_sure',
        gemstone_certificate: FieldCertificateFromSimpleGemstone[params.certificate],
        gemstone_certificate_number: params.certificateNumber,
        gemstone_setting_type: 'gemstone_setting_type_prong',
        gemstone_number_of_stones: `${stoneNum}`,
        gemstone_total_carat_weight: `${carat}`,
        gemstone_total_carat_weight_to: `${caratTo ?? ''}`,
        gemstone_shape: FieldShapeFromSimpleGemstone[params.shape],
        gemstone_type: 'gemstone_type_other',
        stone_type: 'stone_type_other',
        ...(typeId && { item_type: typeId }),
      },
    };
  }

  static createRingItem(params: ItemInputsTypes) {
    const {
      color, clarity, carat, caratTo, isLabGrown,
    } = this.extracted(params);

    let centerStoneSubset: any = {
      type: 'diamond_center_stone',
      properties_set: {
        diamond_color_shade: 'diamond_color_shade_na',
        diamond_cut_grade: 'diamond_cut_grade_very_good',
        diamond_polish: 'diamond_polish_very_good',
        diamond_symmetry: 'diamond_symmetry_very_good',
        diamond_fluorescence_intensity: 'diamond_fluorescence_intensity_none',
        diamond_diamond_treated: 'diamond_diamond_treated_no',
        diamond_clarity_enhanced: 'diamond_clarity_enhanced_no',
        diamond_color_enhanced: 'diamond_color_enhanced_no',
        diamond_chips: 'diamond_chips_none',
        diamond_inclusions_location: 'diamond_inclusions_location_none',
        diamond_inclusions_level: 'diamond_inclusions_level_eye_clean',
        diamond_culet_size: 'diamond_culet_size_none',
        diamond_culet_condition: 'diamond_culet_condition_natural',
        diamond_certificate: FieldCertificateFromSimple[params.certificate],
        diamond_certificate_number: params.certificateNumber,
        diamond_setting_type: 'diamond_setting_type_prong',
        diamond_carat_weight: `${carat}`,
        diamond_carat_weight_to: `${caratTo ?? ''}`,
        diamond_shape: FieldShapeFromSimple[params.shape],
        diamond_color: FieldColorFromSimple[color],
        diamond_clarity: FieldClarityFromSimple[clarity],
        diamond_type: isLabGrown ? 'diamond_type_lab_grown' : 'diamond_type_natural',
        stone_type: isLabGrown ? 'stone_type_lab_grown_diamond' : 'stone_type_diamond',
      },
    };

    if (params.caratClassification === CLASSIFICATION.GEMSTONE) {
      centerStoneSubset = this.getGemstoneStoneSubset(
        params,
        carat,
        caratTo,
        color,
        clarity,
        'gemstone_center_stone',
      );
      delete centerStoneSubset.properties_set.item_type;
    }

    return axios.post<ISubmitItemResponse>(
      `${REACT_APP_SITE_URL}/api/v2/sellers/item/submit_properties`,
      {
        item_type: 'Rings',
        know2c: true,
        user_flow: '',
        submitted_from: isIframe() ? 'widget' : 'app',
        submit_second_item: null,
        seller_item: {
          item_type_id: '1',
          desc: 'Rings',
          initial_transaction_type: '1',
          subsets: {
            1: {
              type: 'jewelry_rings',
              properties_set: {
                item_type: '1',
                jewelry_style_ring: FieldStyleFromSimple[params.setting],
                ring_size: 'ring_size_6_25',
                jewelry_metal_weight: '5',
                jewelry_brand: FieldBrandFromSimple[params.brand],
              },
            },
            2: centerStoneSubset,
          },
        },
        sessionData: getSessionData(),
        input_props: {
          itemType: 'ring',
          style: params.setting,
          shape: params.shape,
          caratWeight: `${carat}`,
          caratWeightTo: `${caratTo ?? ''}`,
          color,
          clarity,
          certificateType: params.certificate,
          certificateId: params.certificateNumber,
          brand: params.brand,
          submitTimestamp: new Date().toISOString(),
          isMeasurement: params.measureByImg,
        },
      },
      this.defaultOptions,
    );
  }

  static createLooseDiamondItem(params: ItemInputsTypes) {
    const {
      color, clarity, carat, caratTo, isLabGrown,
    } = this.extracted(params);

    let looseSubset: any = {
      type: 'diamond_loose_diamonds',
      properties_set: {
        item_type: '4',
        diamond_color_shade: 'diamond_color_shade_na',
        diamond_cut_grade: 'diamond_cut_grade_very_good',
        diamond_polish: 'diamond_polish_very_good',
        diamond_symmetry: 'diamond_symmetry_very_good',
        diamond_fluorescence_intensity: 'diamond_fluorescence_intensity_none',
        diamond_diamond_treated: 'diamond_diamond_treated_no',
        diamond_clarity_enhanced: 'diamond_clarity_enhanced_no',
        diamond_color_enhanced: 'diamond_color_enhanced_no',
        diamond_chips: 'diamond_chips_none',
        diamond_inclusions_location: 'diamond_inclusions_location_none',
        diamond_inclusions_level: 'diamond_inclusions_level_eye_clean',
        diamond_culet_size: 'diamond_culet_size_none',
        diamond_culet_condition: 'diamond_culet_condition_natural',
        diamond_certificate: FieldCertificateFromSimple[params.certificate],
        diamond_certificate_number: params.certificateNumber,
        diamond_setting_type: 'diamond_setting_type_prong',
        diamond_carat_weight: `${carat}`,
        diamond_carat_weight_to: `${caratTo ?? ''}`,
        diamond_shape: FieldShapeFromSimple[params.shape],
        diamond_color: FieldColorFromSimple[color],
        diamond_clarity: FieldClarityFromSimple[clarity],
        diamond_type: isLabGrown ? 'diamond_type_lab_grown' : 'diamond_type_natural',
      },
    };

    if (params.caratClassification === CLASSIFICATION.GEMSTONE) {
      // @ts-ignore
      looseSubset = this.getGemstoneStoneSubset(
        params,
        carat,
        caratTo,
        color,
        clarity,
        'gemstone_loose_gemstones',
        '7',
      );
      delete looseSubset.properties_set.stone_type;
    }

    const itemType = params.caratClassification === CLASSIFICATION.GEMSTONE ? 'Loose Gemstone' : 'Loose Diamonds';

    return axios.post<ISubmitItemResponse>(
      `${REACT_APP_SITE_URL}/api/v2/sellers/item/submit_properties`,
      {
        item_type: itemType,
        know2c: true,
        user_flow: '',
        submitted_from: isIframe() ? 'widget' : 'app',
        submit_second_item: null,
        seller_item: {
          item_type_id: params.caratClassification === CLASSIFICATION.GEMSTONE ? '7' : '1',
          desc: itemType,
          initial_transaction_type: '1',
          subsets: {
            1: looseSubset,
          },
        },
        sessionData: getSessionData(),
        input_props: {
          itemType: ItemTypes.LooseDiamond,
          style: params.setting,
          shape: params.shape,
          caratWeight: carat,
          color,
          clarity,
          certificateType: params.certificate,
          certificateId: params.certificateNumber,
          brand: params.brand,
          submitTimestamp: new Date().toISOString(),
        },
      },
      this.defaultOptions,
    );
  }

  private static extracted(params: ItemInputsTypes) {
    const isLabGrown = params.caratClassification === CLASSIFICATION.LAB_GROWN;
    const isGemstone = params.caratClassification === CLASSIFICATION.GEMSTONE;

    const color = params.color || (isGemstone ? GemstoneColor.NA : DiamondColor.NotSure);
    const clarity = params.clarity || DiamondClarity.NotSure;

    const { carat } = params;
    const caratTo = carat === 0 ? 0 : params.caratRangeTo;

    return {
      color, clarity, carat, caratTo, isLabGrown,
    };
  }

  static async createBraceletItem(params: SubmitState) {
    const {
      color, clarity, carat, caratTo, isLabGrown,
    } = this.extracted(params);

    const isCustomBrand = params.brand === 'other' && params.customBrand.length > 0;
    const customBrandName = params.customBrand.trim();

    const inputProps = {
      itemType: ItemTypes.Bracelet,
      style: params.style,
      brand: params.brand,
      shape: DiamondShape.Other,
      color,
      clarity,
      caratWeight: carat,
      caratWeightTo: caratTo,
      metalType: params.metalType,
      numDiamonds: params.diamondNumber.toString(),
      submitTimestamp: new Date().toISOString(),
      ...(isCustomBrand && { customName: customBrandName }),
    };

    let secondSubset: any = {
      type: 'diamond_minor_stone_batch',
      properties_set: {
        diamond_number_of_stones: params.diamondNumber.toString(),
        diamond_total_carat_weight: `${carat}`,
        diamond_total_carat_weight_to: `${caratTo ?? ''}`,
        diamond_shape: FieldShapeFromSimple[DiamondShape.Other],
        diamond_average_color_grade: 'diamond_average_color_grade_not_sure',
        diamond_average_clarity_grade: 'diamond_average_clarity_grade_not_sure',
        diamond_type: isLabGrown ? 'diamond_type_lab_grown' : 'diamond_type_natural',
        stone_type: isLabGrown ? 'stone_type_lab_grown_diamond' : 'stone_type_diamond',
      },
    };

    if (params.caratClassification === CLASSIFICATION.GEMSTONE) {
      secondSubset = this.getGemstoneMultiStoneSubset(
        { ...params, ...{ shape: 'other' } },
        carat,
        caratTo,
        params.diamondNumber,
        'gemstone_minor_stone_batch',
      );
      delete (secondSubset as any).properties_set?.item_type;
    }

    return axios.post<ISubmitItemResponse>(
      `${REACT_APP_SITE_URL}/api/v2/sellers/item/submit_properties`,
      {
        item_type: 'Bracelets',
        know2c: true,
        user_flow: '',
        submitted_from: isIframe() ? 'widget' : 'app',
        submit_second_item: null,
        seller_item: {
          item_type_id: '1',
          desc: 'Bracelets',
          premium_brand: params.premiumBrand,
          // initial_transaction_type: '1',
          subsets: {
            1: {
              type: 'jewelry_bracelets',
              properties_set: {
                item_type: '7',
                jewelry_style_bracelet: FieldBraceletStyleFromSimple[params.style],
                jewelry_metal_type: params.metalType
                  ? FieldMetaTypeFromSimple[params.metalType]
                  : 'jewelry_metal_type_other',
                ...(params.metalWeight && { jewelry_metal_weight: params.metalWeight }),
                ...(params.brand && { jewelry_brand: FieldBrandFromSimple[params.brand] }),
                ...(params.box && {
                  jewelry_original_box_papers: `jewelry_original_box_papers_${params.box.toLowerCase()}`,
                }),
                ...(params.papers && {
                  jewelry_includes_papers: `jewelry_includes_papers_${params.papers.toLowerCase()}`,
                }),
                ...(isCustomBrand && {
                  jewelry_custom_brand_name: customBrandName,
                }),
              },
            },
            2: secondSubset,
          },
        },
        sessionData: getSessionData(),
        input_props: inputProps,
      },
      this.defaultOptions,
    );
  }

  static async createNecklaceItem(params: SubmitState) {
    const {
      color, clarity, carat, caratTo, isLabGrown,
    } = this.extracted(params);

    const isCustomBrand = params.brand === 'other' && params.customBrand.length > 0;
    const customBrandName = params.customBrand.trim();
    let secondSubset = null;
    let inputProps = {
      itemType: ItemTypes.Necklace.toLowerCase(),
      style: params.style.toLowerCase(),
      brand: params.brand.toLowerCase(),
      shape: params.shape.toLowerCase(),
      color: DiamondColor.NotSure.toLowerCase(),
      clarity: DiamondClarity.NotSure.toLowerCase(),
      submitTimestamp: new Date().toISOString(),
      ...(isCustomBrand && { customName: customBrandName }),
    };

    const SubsetStyle = params.secondarySubset;
    if (SubsetStyle === Subsets.CenterStone) {
      inputProps = {
        ...inputProps,
        ...{
          metalType: FieldMetaTypeFromSimple[params.metalType],
          caratWeight: carat,
          caratWeightTo: caratTo,
        },
      };

      if (params.caratClassification === CLASSIFICATION.GEMSTONE) {
        secondSubset = this.getGemstoneStoneSubset(
          params,
          carat,
          caratTo,
          color,
          clarity,
          'gemstone_center_stone',
        );
        delete (secondSubset as any).properties_set?.item_type;
      } else {
        secondSubset = {
          type: SubsetStyle,
          properties_set: {
            diamond_shape: FieldShapeFromSimple[params.shape],
            diamond_carat_weight: `${carat}`,
            diamond_carat_weight_to: `${caratTo ?? ''}`,
            diamond_color: FieldColorFromSimple[DiamondColor.NotSure],
            diamond_clarity: FieldClarityFromSimple[DiamondClarity.NotSure],
            diamond_type: isLabGrown ? 'diamond_type_lab_grown' : 'diamond_type_natural',
            stone_type: isLabGrown ? 'stone_type_lab_grown_diamond' : 'stone_type_diamond',
          },
        };
      }
    }
    if (SubsetStyle === Subsets.MinorStoneBatch) {
      inputProps = {
        ...inputProps,
        ...{
          numDiamonds: params.diamondNumber,
          caratWeightTotal: carat,
          caratWeightTotalTo: caratTo,
        },
      };

      if (params.caratClassification === CLASSIFICATION.GEMSTONE) {
        secondSubset = this.getGemstoneMultiStoneSubset(
          params,
          carat,
          caratTo,
          params.diamondNumber,
          'gemstone_minor_stone_batch',
        );
        delete (secondSubset as any).properties_set?.item_type;
      } else {
        secondSubset = {
          type: SubsetStyle,
          properties_set: {
            diamond_number_of_stones: params.diamondNumber,
            diamond_total_carat_weight: `${carat}`,
            diamond_total_carat_weight_to: `${caratTo ?? ''}`,
            diamond_type: isLabGrown ? 'diamond_type_lab_grown' : 'diamond_type_natural',
            stone_type: isLabGrown ? 'stone_type_lab_grown_diamond' : 'stone_type_diamond',
            diamond_shape: FieldShapeFromSimple[params.shape],
            diamond_average_color_grade: 'diamond_average_color_grade_na',
            diamond_average_clarity_grade: 'diamond_average_clarity_grade_na',
            diamond_certificate: FieldCertificateFromSimple[CertificateType.None],
          },
        };
      }
    }

    return axios.post<ISubmitItemResponse>(
      `${REACT_APP_SITE_URL}/api/v2/sellers/item/submit_properties`,
      {
        item_type: 'Necklace',
        know2c: true,
        user_flow: '',
        submitted_from: isIframe() ? 'widget' : 'app',
        submit_second_item: null,
        seller_item: {
          item_type_id: '1',
          desc: 'Necklace',
          premium_brand: params.premiumBrand,
          initial_transaction_type: '1',
          subsets: {
            1: {
              type: 'jewelry_necklaces',
              properties_set: {
                item_type: '1',
                jewelry_style_necklace: FieldNecklaceStyleFromSimple[params.style],
                jewelry_metal_type: params.metalType
                  ? FieldMetaTypeFromSimple[params.metalType]
                  : 'jewelry_metal_type_other',
                ...(params.metalWeight && { jewelry_metal_weight: params.metalWeight }),
                ...(params.brand && { jewelry_brand: FieldBrandFromSimple[params.brand] }),
                ...(params.box && {
                  jewelry_original_box_papers: `jewelry_original_box_papers_${params.box.toLowerCase()}`,
                }),
                ...(params.papers && {
                  jewelry_includes_papers: `jewelry_includes_papers_${params.papers.toLowerCase()}`,
                }),
                ...(isCustomBrand && {
                  jewelry_custom_brand_name: customBrandName,
                }),
              },
            },
            ...(secondSubset && { 2: secondSubset }),
          },
        },
        sessionData: getSessionData(),
        input_props: inputProps,
      },
      this.defaultOptions,
    );
  }

  static async createWatchItem(params: SubmitState) {
    const inputProps = {
      itemType: ItemTypes.Watch.toLowerCase(),
      brand: params.brand.toLowerCase(),
      condition: params.condition.toLowerCase(),
      papers: params.papers.toLowerCase(),
      model: params.model.toLowerCase(),
      box: params.box.toLowerCase(),
      bandMaterial: params.bandMaterial.toLowerCase(),
      caseMaterial: params.caseMaterial.toLowerCase(),
      gender: params.gender.toLowerCase(),
      submitTimestamp: new Date().toISOString(),
    };

    const dataSet = {
      item_type: '3',
      luxury_watch_brand: FieldWatchBrandFromSimple[params.brand],
      luxury_watch_condition: FieldConditionFromSimple[params.condition],
      luxury_watch_includes_papers: `luxury_watch_includes_papers_${inputProps.papers || 'no'}`,
      luxury_watch_model: params.model,
      luxury_watch_original_box_papers: `luxury_watch_original_box_papers_${
        inputProps.box || 'no'
      }`,
      // luxury_watch_band_material: FieldBandMaterialFromSimple[params.bandMaterial],
      // luxury_watch_case_material: FieldCaseMaterialFromSimple[params.caseMaterial],
      // luxury_watch_gender: `luxury_watch_gender_${inputProps.gender}`,
    };

    if (params.brand === 'other') {
      Object.assign(dataSet, { luxury_watch_brand_custom_name: params.customBrand });
      Object.assign(inputProps, { customName: params.customBrand });
    }

    return axios.post<ISubmitItemResponse>(
      `${REACT_APP_SITE_URL}/api/v2/sellers/item/submit_properties`,
      {
        item_type: 'Watches',
        know2c: true,
        user_flow: '',
        submitted_from: isIframe() ? 'widget' : 'app',
        submit_second_item: null,
        seller_item: {
          item_type_id: '3',
          desc: 'Watches',
          premium_brand: params.premiumBrand,
          initial_transaction_type: '1',
          subsets: {
            1: {
              type: 'luxury_watch_watches',
              properties_set: dataSet,
            },
          },
        },
        sessionData: getSessionData(),
        input_props: inputProps,
      },
      this.defaultOptions,
    );
  }

  static async createEarringsItem(params: SubmitState) {
    const {
      color, clarity, carat, caratTo, isLabGrown,
    } = this.extracted(params);

    const isCustomBrand = params.brand === 'other' && params.customBrand.length > 0;
    const customBrandName = params.customBrand.trim();

    let secondSubset = null;
    let inputProps = {
      itemType: 'earring',
      styleEarrings: params.style.toLowerCase(),
      metalType: FieldMetaTypeFromSimple[MetalTypes.Other],
      metalWeight: 0,
      brand: params.brand.toLowerCase(),
      ...(isCustomBrand && { customName: customBrandName }),
    };

    const SubsetStyle = params.secondarySubset;
    if (SubsetStyle === Subsets.CenterStone) {
      inputProps = {
        ...inputProps,
        ...{
          caratWeight: carat,
          caratWeightTo: caratTo,
          certificateType: params.certificate,
          submitTimestamp: new Date().toISOString(),
        },
      };

      if (params.caratClassification === CLASSIFICATION.GEMSTONE) {
        secondSubset = this.getGemstoneStoneSubset(
          params,
          carat,
          caratTo,
          color,
          clarity,
          'gemstone_center_stone',
        );
        delete (secondSubset as any).properties_set?.item_type;
      } else {
        secondSubset = {
          type: SubsetStyle,
          properties_set: {
            diamond_shape: FieldShapeFromSimple[params.shape],
            diamond_carat_weight: `${carat}`,
            diamond_carat_weight_to: `${caratTo ?? ''}`,
            diamond_color: FieldColorFromSimple[DiamondColor.NotSure],
            diamond_clarity: FieldClarityFromSimple[DiamondClarity.NotSure],
            diamond_certificate: FieldCertificateFromSimple[params.certificate],
            diamond_certificate_number: params.certificateNumber,
            diamond_type: isLabGrown ? 'diamond_type_lab_grown' : 'diamond_type_natural',
            stone_type: isLabGrown ? 'stone_type_lab_grown_diamond' : 'stone_type_diamond',
          },
        };
      }
    }
    if (SubsetStyle === Subsets.MinorStoneBatch) {
      inputProps = {
        ...inputProps,
        ...{
          itemType: 'earring',
          style: params.style,
          numberOfStones: params.diamondNumber,
          totalCaratWeight: carat,
          totalCaratWeightTo: caratTo,
          caratWeight: params.carat,
          shape: params.shape,
          certificateType: params.certificate,
          certificateId: params.certificateNumber,
          submitTimestamp: new Date().toISOString(),
        },
        ...(params.brand && { brand: params.brand }),
      };

      if (params.caratClassification === CLASSIFICATION.GEMSTONE) {
        secondSubset = this.getGemstoneMultiStoneSubset(
          params,
          carat,
          caratTo,
          params.diamondNumber,
          'gemstone_minor_stone_batch',
        );
        delete (secondSubset as any).properties_set?.item_type;
      } else {
        secondSubset = {
          type: SubsetStyle,
          properties_set: {
            diamond_number_of_stones: params.diamondNumber,
            diamond_total_carat_weight: `${carat}`,
            diamond_total_carat_weight_to: `${caratTo ?? ''}`,
            diamond_shape: FieldShapeFromSimple[params.shape],
            diamond_average_color_grade: 'diamond_average_color_grade_na',
            diamond_average_clarity_grade: 'diamond_average_clarity_grade_na',
            diamond_certificate: FieldCertificateFromSimple[CertificateType.None],
            diamond_type: isLabGrown ? 'diamond_type_lab_grown' : 'diamond_type_natural',
            stone_type: isLabGrown ? 'stone_type_lab_grown_diamond' : 'stone_type_diamond',
          },
        };
      }
    }

    return axios.post<ISubmitItemResponse>(
      `${REACT_APP_SITE_URL}/api/v2/sellers/item/submit_properties`,
      {
        item_type: 'Earrings',
        know2c: true,
        user_flow: '',
        submitted_from: isIframe() ? 'widget' : 'app',
        submit_second_item: null,
        seller_item: {
          item_type_id: '1',
          desc: 'Earrings',
          premium_brand: params.premiumBrand,
          initial_transaction_type: '1',
          subsets: {
            1: {
              type: 'jewelry_earrings',
              properties_set: {
                item_type: '1',
                jewelry_style_earring: FieldEarringsStyleFromSimple[params.style],
                jewelry_metal_type: params.metalType
                  ? FieldMetaTypeFromSimple[params.metalType]
                  : 'jewelry_metal_type_other',
                ...(params.metalWeight && { jewelry_metal_weight: params.metalWeight }),
                ...(params.brand && { jewelry_brand: FieldBrandFromSimple[params.brand] }),
                ...(params.box && {
                  jewelry_original_box_papers: `jewelry_original_box_papers_${params.box.toLowerCase()}`,
                }),
                ...(params.papers && {
                  jewelry_includes_papers: `jewelry_includes_papers_${params.papers.toLowerCase()}`,
                }),
                ...(isCustomBrand && {
                  jewelry_custom_brand_name: customBrandName,
                }),
              },
            },
            ...(secondSubset && { 2: secondSubset }),
          },
        },
        sessionData: getSessionData(),
        // worthy-personalizer can't process event with earring in implementation moment
        input_props: inputProps,
      },
      this.defaultOptions,
    );
  }

  static async register(params: SubmitState['registration'], bundleId: number) {
    let signature = '';
    try {
      const signatureKey = process.env.REACT_APP_SIGNATURE_KEY || '-';

      const metaData = JSON.stringify({
        timestamp: Date().toString(),
        active_fields: params?.activeFields?.length ? params.activeFields.map(toSnakeCase) : [],
      });

      const keyHash = CryptoJS.enc.Utf8.parse(signatureKey);
      const iv = CryptoJS.lib.WordArray.random(16);
      const encrypted = CryptoJS.AES.encrypt(metaData, keyHash, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      signature = CryptoJS.enc.Base64.stringify(iv.concat(encrypted.ciphertext));
    } catch (error: any) {
      const mgs = 'Encryption error on registration request';
      if (window.rollbar && window.rollbar.error) window.rollbar.error(mgs, error);
      console.error(mgs, error);
    }

    const data = {
      first_name: params.firstName,
      last_name: params.lastName,
      email: params.email,
      phone: params.phoneNumber || DEFAULT_PHONE,
      referer: CookieStore.getReferer(),
      friendbuy_referer: CookieStore.getRefererFriendbuy(),
      contact_preference: 'phone_call',
      bundle_id: bundleId,
      user_flow: null, // ?
      optional_phone_exp: true,
      sms_opt_in: params.smsConsent || false,
      signature,
    };

    return axios.post(
      `${REACT_APP_SITE_URL}/api/v2/sellers/registration`,
      data,
      this.defaultOptions,
    );
  }

  static async updatePhoneNumber(params: SubmitState['registration'], userId: string | undefined) {
    return axios.post(
      `${REACT_APP_SITE_URL}/api/v2/sellers/user/update_missing_details`,
      {
        phone: params.phoneNumber || DEFAULT_PHONE,
        user_id: userId,
      },
      this.defaultOptions,
    );
  }

  static async uploadImage(itemId: string, data: FormData) {
    return axios
      .post<
    any,
    AxiosResponse<{
      paths: string[]; // 'https://cdn1.worthy.com/item_submission_photo/864297/1'
    }>
    >(`${REACT_APP_SITE_URL}/api/v2/sellers/item/${itemId}/upload_images`, data, {
      ...this.defaultOptions,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((r) => {
        if (r.status === 200 && r.data.paths) {
          return r.data;
        }
        throw new Error('uploadImage failed');
      });
  }

  static async removeImages(files: string[], itemId: string) {
    return axios
      .post<
    any,
    AxiosResponse<{
      removed: boolean; // true
      status: string; // 'ok'
    }>
    >(
      `${REACT_APP_SITE_URL}/api/v2/sellers/item/${itemId}/remove_images`,
      {
        files,
      },
      this.defaultOptions,
    )
      .then((r) => {
        if (r.status === 200) {
          return r.data;
        }
        throw new Error('removeImage failed');
      });
  }

  static async estimate(itemId: string) {
    return axios
      .get(`${REACT_APP_SITE_URL}/api/v2/sellers/item/${itemId}/estimate`, this.defaultOptions)
      .then((r) => r.data);
  }

  static async generateItemEstimationByPublicId(itemId: string, measureByImg: boolean) {
    return axios
      .post(
        `${REACT_APP_SITE_URL}/api/v2/sellers/item/${itemId}/generate_estimation`,
        {
          isMeasurement: measureByImg,
        },
        this.defaultOptions,
      )
      .then((r) => r.data);
  }

  static async registerWithGoogle(credential: string) {
    return axios.post(
      `${REACT_APP_SITE_URL}/api/v2/sellers/register_with_google`,
      { credential },
      {
        withCredentials: true,
      },
    );
  }

  static async getUserDataFromGoogleCredential(credential: string) {
    return axios
      .get(
        `${process.env.REACT_APP_SUBMIT_BE_URL}/get-user-data-from-google-credential?credential=${credential}`,
        this.defaultOptions,
      )
      .then((r) => r.data);
  }

  /**
   * Request one-time OTP code via authenticator service
   */
  static async sendOtpCode(
    params:
    { medium: MediumTypes.email | MediumTypes.anyMedium, email: string }
    | { medium: MediumTypes.sms, phone: string },
  ): Promise<{ requestId: string }> {
    const { medium } = params;
    const email = 'email' in params ? params.email : '';
    const phone = 'phone' in params ? params.phone : '';

    const response = await axios.post(
      `${envUrls.authenticator}/seller/one-time-password`,
      { email, phone, medium },
      this.defaultOptions,
    );
    const { request_id: requestId } = response.data;
    return { requestId };
  }

  /**
   * Sign in using OTP code via authenticator service
   */
  static async signInWithCode(
    value: string,
    otpCode: string,
    requestId: string,
    medium: 'email' | 'sms' | 'anyMedium',
  ): Promise<void> {
    await axios.post(
      `${envUrls.authenticator}/seller/otp-login`,
      {
        email: medium !== 'sms' ? value : '',
        phone: medium === 'sms' ? value : '',
        code: otpCode,
        requestId,
        medium,
      },
      this.defaultOptions,
    );
  }

  static async performMonolithSignin(): Promise<void> {
    return axios.post(`${REACT_APP_SITE_URL}/api/v2/sellers/sign_in`, {}, this.defaultOptions);
  }

  static async scheduleShipping({
    itemId,
    shippingType,
    itemIds,
    data,
  }: {
    itemId: string;
    shippingType: SchedulingType.PICKUP | SchedulingType.DROPOFF;
    itemIds: string[];
    data: IShippingPickupData | IShippingDropOffData;
  }): Promise<SchedulingDetails> {
    const requestBody = {
      shippingType,
      publicId: itemId,
      itemIds,
      params: {
        ...data,
        expectFullResponse: true,
      },
    };

    try {
      const resp = await axios.post<SchedulingDetails>(
        `${REACT_APP_SELLER_DASHBOARD_BE_URL}/api/v1/schedule_shipping`,
        requestBody,
        this.defaultOptions,
      );
      return resp.data;
    } catch (err) {
      throw new Error(JSON.stringify(err));
    }
  }

  static async createShipping(itemId: string) {
    return axios.post(
      `${REACT_APP_SELLER_DASHBOARD_BE_URL}/api/v1/create_shipping`,
      {
        itemId,
      },
      this.defaultOptions,
    );
  }

  static async createShipment({
    itemPublicIds,
    addressObj,
    user,
  }: GenerateShippingParams): Promise<any> {
    const requestBody = {
      address: addressObj,
      user,
      auto_correct: true,
      item_public_ids: itemPublicIds,
    };

    try {
      const { data } = await axios.post<any>(
        `${REACT_APP_SITE_URL}/api/v2/sellers/item/create_shipping`,
        requestBody,
        this.defaultOptions,
      );
      return data;
      return mockResponseForCreateShipping;
    } catch (err) {
      throw new Error(JSON.stringify(err));
      return mockResponseForCreateShipping;
    }
  }

  static async updateUserPhoneNumber(
    phoneNumber: string,
    userId: number,
  ): Promise<GeneralApiRes['status']> {
    try {
      const { data } = await axios.post<GeneralApiRes['status']>(
        `${REACT_APP_SITE_URL}/api/v2/sellers/user/update_missing_details`,
        {
          phone: phoneNumber,
          user_id: userId,
        },
        this.defaultOptions,
      );
      return data;
    } catch (err) {
      throw new Error(JSON.stringify(err));
    }
  }

  static async sendShippingIntent(itemPublicId: string): Promise<void> {
    try {
      await axios.post<void>(
        `${REACT_APP_SELLER_DASHBOARD_BE_URL}/api/v1/shipping_intent`,
        {
          itemPublicIds: [itemPublicId],
        },
        this.defaultOptions,
      );
    } catch (err) {
      throw new Error(JSON.stringify(err));
    }
  }

  static async logUserAction(
    message: string,
    itemPublicId: string,
  ): Promise<GeneralApiRes['status']> {
    const requestBody = {
      page: 'listing_page',
      id: itemPublicId,
      version: '1.2',
      component_key: message,
    };

    try {
      const { data } = await axios.post<GeneralApiRes['status']>(
        `${REACT_APP_SITE_URL}/api/v2/sellers/user_actions/item/${itemPublicId}/events`,
        requestBody,
        this.defaultOptions,
      );
      return data;
    } catch (err) {
      throw new Error(JSON.stringify(err));
    }
  }
}
